import React from 'react';
import ErrorBoundary from '../../ErrorBoundary';
import LightBoxPopup from '../LightBox';
import LoadingIndicator from '../../LoadingIndicator';
import { VideoPlayer } from '../../VideoPlayer/LoadableVideoPlayer';
import s from './Video.scss';
var applyTheme = function (player) {
    return player.updateTheme({
        progressColor: '#00ff77',
    });
};
var VideoPopup = function (_a) {
    var onRequestClose = _a.onRequestClose, source = _a.source, autoPlay = _a.autoPlay, posterFrame = _a.posterFrame;
    return (React.createElement(LightBoxPopup, { onRequestClose: onRequestClose },
        React.createElement(ErrorBoundary, { debugComponent: "VideoPopup" },
            source && (React.createElement(VideoPlayer, { className: s['player'], src: source, autoPlay: autoPlay, fillAllSpace: true, loadingCover: posterFrame, onInit: applyTheme })),
            !source && (React.createElement("div", { className: s['player-loading'] },
                React.createElement(LoadingIndicator, { view: "daSymbol" }))))));
};
VideoPopup.displayName = 'VideoPopup';
export default VideoPopup;
//# sourceMappingURL=Video.js.map